import { COMMAND_PALETTE_ISSUE_ACTIONS } from '../constants';

export const getCommandPaletteIssueActionsHeader = (issueKey: string | undefined) =>
	`${COMMAND_PALETTE_ISSUE_ACTIONS}-${issueKey || ''}`;

export { getCommandPaletteIssueActionsPriority } from './get-command-palette-issue-actions-priority';
export { noSortNoFilterOverride } from './sort-filter-overrides/no-sort-no-filter-override/index.tsx';
